var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenCircleTick(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 0C9.63021 0 0 9.63021 0 21.5C0 33.3698 9.63021 43 21.5 43C33.3698 43 43 33.3698 43 21.5C43 9.63021 33.3698 0 21.5 0ZM32.5635 16.3042L19.9323 28.9802C19.5292 29.3833 18.9469 29.652 18.3644 29.652C17.782 29.652 17.1999 29.4279 16.7966 28.9802L10.4365 22.6198C9.5407 21.724 9.5407 20.3355 10.4365 19.4394C11.3322 18.5437 12.7208 18.5437 13.6168 19.4394L18.3647 24.1873L29.4282 13.1237C30.324 12.228 31.7125 12.228 32.6086 13.1237C33.4594 14.0198 33.4594 15.4083 32.5636 16.3041L32.5635 16.3042Z",
    fill: "#34C759"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCircleTick);
export default __webpack_public_path__ + "static/media/green-circle-tick.c8a0bdd149e73468598755d487fb8062.svg";
export { ForwardRef as ReactComponent };